<template>
  <v-autocomplete
    v-model="selected"
    :items.sync="items"
    item-text="key"
    item-value="key"
    :label="label"
    :clearable="clearable"
    return-object
    hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {ItemGroupModel} from "@/modules/redactor/models/item/core/ItemGroupModel";

export default {
  name: "r-item-group-dropdown",

  props: {
    model: VueTypes.instanceOf(ItemGroupModel),
    label: VueTypes.string.def("Item Group"),
    clearable: VueTypes.bool.def(false)
  },

  data() {
    return {
      items: [],
      selected: null
    };
  },

  watch: {
    model(newVal) {
      this.selected = newVal ?? ItemGroupModel.getNone(this.items);
    },

    selected(newVal) {
      if (ItemGroupModel.isNone(newVal)) {
        this.$emit("update:model", ItemGroupModel.getNone(this.items));
      } else {
        this.$emit("update:model", newVal);
      }
    }
  },

  created() {
    this.items = RedactorUtils.getItemGroups();

    this.selected = this.model ?? ItemGroupModel.getNone(this.items);
  },
}
</script>